import { useLessonsStore } from './store'
import { useLessonsApi } from '../../api/lessons/index.hook'
import { useDisciplineRefresh } from '../discipline-refresh.hook'

interface LessonsRefreshReturn {
  refreshLessons: (deletedIds?: number[]) => Promise<void>
}

/**
 * Rereads the page after a write, and the discipline with it: the balance counters change with every lesson.
 * The list reads a replica, so a lesson deleted a moment ago may still come back; it is kept out.
 */
export const useLessonsRefresh = (): LessonsRefreshReturn => {
  const route = useRoute()
  const store = useLessonsStore()
  const { refreshDiscipline } = useDisciplineRefresh()

  const refreshLessons = async (deletedIds: number[] = []): Promise<void> => {
    void refreshDiscipline()

    await useLessonsApi({ disciplineId: route.params.id as string })

    if (deletedIds.length) {
      store.setLessons(store.getLessons.filter(lesson => !deletedIds.includes(lesson.id)))
    }
  }

  return {
    refreshLessons,
  }
}
